var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.118 0C2.74466 0 0 2.74442 0 6.118C0 8.68805 1.56642 12.7365 4.65572 18.1503C4.95948 18.6823 5.50615 19 6.118 19C6.72985 19 7.27652 18.6823 7.58028 18.1503C10.6696 12.7363 12.2358 8.68805 12.2358 6.118C12.236 2.74442 9.49134 0 6.118 0ZM6.74476 17.6734C6.6144 17.9016 6.38015 18.038 6.118 18.038C5.85585 18.038 5.62159 17.9016 5.49148 17.6734C2.52844 12.4806 0.962266 8.48482 0.962266 6.11776C0.962266 3.27497 3.27497 0.962025 6.118 0.962025C8.96103 0.962025 11.274 3.27497 11.274 6.118C11.274 8.48482 9.7078 12.4808 6.74476 17.6734Z",
    fill: "#011740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11764 3.38477C4.61063 3.38477 3.38477 4.61063 3.38477 6.11764C3.38477 7.62465 4.61063 8.85027 6.11764 8.85027C7.62465 8.85027 8.85051 7.62441 8.85051 6.1174C8.85051 4.61039 7.62465 3.38477 6.11764 3.38477ZM6.11764 7.88825C5.14118 7.88825 4.34679 7.09385 4.34679 6.1174C4.34679 5.14094 5.14118 4.34679 6.11764 4.34679C7.09409 4.34679 7.88849 5.14118 7.88849 6.11764C7.88849 7.09409 7.09409 7.88825 6.11764 7.88825Z",
    fill: "#011740"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAddress);
export default __webpack_public_path__ + "static/media/pin_address.dbd81c1c.svg";
export { ForwardRef as ReactComponent };